import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryShowcase from './components/CategoryShowcase';
import QualityFeatures from './components/QualityFeatures';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { testimonials } from '@/mocks/home';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '久久久',
    url: 'https://www.jiujiujiu.com',
    description: '久久久——持久稳定的品质体验，经久不衰的信赖之选。提供经久耐用的产品与持续有效的服务，让每一次选择都值得长久信赖。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.jiujiujiu.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '久久久',
    url: 'https://www.jiujiujiu.com',
    description: '久久久代表持久、稳定与长效的极致追求，提供经久耐用的产品与持续有效的服务。',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-400-888-9999',
      contactType: 'customer service',
      availableLanguage: 'Chinese',
    },
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '久久久 - 持久稳定的品质体验',
    description: '久久久——持久稳定的品质体验，经久不衰的信赖之选。提供经久耐用的产品与持续有效的服务。',
    url: 'https://www.jiujiujiu.com',
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      { '@type': 'Question', name: '久久久的产品为什么比其他品牌更耐用？', acceptedAnswer: { '@type': 'Answer', text: '久久久坚持"三好原则"：好材质（只选用上等原材料）、好工艺（传承匠心制造工艺）、好服务（超长质保承诺）。从源头到成品，每一个环节都严格把控，确保产品品质远超行业标准。' } },
      { '@type': 'Question', name: '久久久的质保政策具体包括哪些内容？', acceptedAnswer: { '@type': 'Answer', text: '久久久不同品类产品提供差异化的超长质保服务：实木家具10年结构质保、床垫15年耐用质保、锅具25年锅体质保、保温杯终身防锈等。质保流程简单透明：联系客服→上传照片→24小时确认→48小时发货新品→寄回旧品（久久久承担运费）。' } },
      { '@type': 'Question', name: '久久久的产品价格是否偏高？如何理解性价比？', acceptedAnswer: { '@type': 'Answer', text: '久久久倡导"少即是多、精即是久"的消费理念。从长期使用成本来看，久久久产品更加划算。高品质产品带来的使用体验和安心感，也是廉价产品无法比拟的。' } },
      { '@type': 'Question', name: '久久久的产品是否有环保认证？', acceptedAnswer: { '@type': 'Answer', text: '久久久高度重视环保和可持续发展，坚持使用可回收材料、减少过度包装。多款产品已通过FSC森林认证、OEKO-TEX生态纺织品认证等国际环保标准。"经久耐用"本身就是最大的环保。' } },
    ],
  };

  return (
    <>
      <SchemaOrg type="WebSite" data={websiteSchema} />
      <SchemaOrg type="Organization" data={orgSchema} />
      <SchemaOrg type="WebPage" data={webpageSchema} />
      <SchemaOrg type="FAQPage" data={faqSchema} />

      <Navbar />

      <main>
        <HeroSection />

        <CategoryShowcase />

        <QualityFeatures />

        <LatestArticles />

        <section className="py-16 md:py-20 bg-background-100" aria-labelledby="testimonials-heading">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="text-center mb-12 md:mb-14">
              <p className="text-xs font-label tracking-[0.15em] uppercase text-foreground-500 mb-3">用户口碑</p>
              <h2 id="testimonials-heading" className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
                经久不衰的信赖之选
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {testimonials.map((t) => (
                <div key={t.name} className="bg-background-50 rounded-xl p-6 md:p-7 border border-background-200/70">
                  <div className="flex items-center gap-3 mb-4">
                    <img src={t.avatar} alt={t.name} className="w-10 h-10 rounded-full object-cover" />
                    <div>
                      <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{t.content}</p>
                  <div className="flex gap-1 mt-4 text-yellow-400">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <FAQSection />

        <CTASection />
      </main>

      <Footer />
    </>
  );
}